import UnauthView from './UnauthView'

export default UnauthView



// WEBPACK FOOTER //
// ./src/components/UnauthView/index.js